import { Box, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

interface Props {
  isExpanded: boolean;
  onToggleAll: () => void;
  disabled?: boolean;
}

const MonthlyHeader = ({ isExpanded, onToggleAll, disabled = false }: Props) => (
  <Box display="flex" justifyContent="space-between" alignItems="center">
    <Typography variant="h5" className="report-heading">
      Monthly Usage Report
    </Typography>
    <div
      className={`btn btn-primary expand-toggle-button ${disabled ? 'disabled' : ''}`}
      style={{
        padding: '6px 12px',
        lineHeight: '1.5',
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
      }}
      onClick={() => {
        if (!disabled) onToggleAll();
      }}
    >
      {isExpanded ? (
        <>
          <RemoveIcon className="expand-icon" />
          <span className="expand-text">Collapse All</span>
        </>
      ) : (
        <>
          <AddIcon className="expand-icon" />
          <span className="expand-text">Expand All</span>
        </>
      )}
    </div>
  </Box>
);

export default MonthlyHeader;
